export default __webpack_public_path__ + "2c480a3244ec4bc6a6d535179f0da359.svg";